 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"edf3535aced653b0e178639fa7f04ee143795c54","2":"48fd66a7b8563289ea94669bc022bb0d150ec79b","3":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","4":"c05b8182","5":"component---src-pages-layout-js","6":"f68b6560540997019da160705c016bf18f9f73c7","7":"9792b413b5a274ce46bf46d519555576faa75f82","8":"4ad82c5e","9":"component---src-pages-integration-builder-sections-code-tsx","18":"3dcc3d58","29":"c46c4a8f","32":"component---src-pages-404-js","33":"component---src-pages-banner-js","34":"component---src-pages-classic-home-js","35":"component---src-pages-docs-template-js","36":"component---src-pages-home-js","37":"component---src-pages-index-js","38":"component---src-pages-integration-builder-index-tsx","39":"component---src-pages-integration-builder-sections-build-tsx","40":"component---src-pages-integration-builder-sections-card-generator-tsx","41":"component---src-pages-integration-builder-sections-configure-tsx","42":"component---src-pages-integration-builder-sections-demo-tsx","43":"component---src-pages-integration-builder-sections-help-modal-tsx","44":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","45":"component---src-pages-integration-builder-sections-preview-tsx","46":"component---src-pages-integration-builder-sections-take-live-tsx","47":"component---src-pages-internal-js","48":"component---src-pages-signup-js","49":"component---src-pages-signupauto-js","50":"component---src-pages-support-js","51":"component---src-pages-thankyou-js","52":"component---src-pages-unsubscribe-js","53":"component---src-templates-template-layout-js","57":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"4385a51a15dc099f07de","2":"27731b261407923bea65","3":"d51a5f3bd083ca8aad14","4":"c3f400514f4ed73a1ae1","5":"fe82e0af1d3ca25fbebf","6":"fc3284454618a73f34fd","7":"2575ceb331220b86699e","8":"4b1694f3179252902c46","9":"49d3e780eecd78ba9195","18":"a1ddd295c170618e5cf7","29":"53857c947bdd9cde8a1b","32":"32fb91619db4dbb55ffa","33":"eee0c3fe642e7a2c9bfe","34":"a757ee4a40b721726f5c","35":"704d9c9e389fb4c606fd","36":"39ec456bed1b9810b77b","37":"75c099eff096f3b4c472","38":"9b7149ec476885336bcf","39":"eaf3995a294fd753a152","40":"13c96147388de667f353","41":"5e668c36645ca54a3de4","42":"3b6b0238b82a36c71efd","43":"ee93f5722da71a48851c","44":"68e45eaa836d2825fae4","45":"b1a59fed72b72e307c02","46":"6614ddbc1c020a9a30cc","47":"4b718479c980683ce150","48":"04f4e94cae4f7ebea355","49":"ad0b3530843e0c05e485","50":"1df47ea5395db978cec1","51":"45707f7aeab92d0b4a46","52":"3608fed6836d0dcbdffe","53":"b318919171ee00b059e5","57":"4dca5e52384c2b78ba7d","62":"1b45f029214f346a768f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"edf3535aced653b0e178639fa7f04ee143795c54","2":"48fd66a7b8563289ea94669bc022bb0d150ec79b","3":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","4":"c05b8182","5":"component---src-pages-layout-js","6":"f68b6560540997019da160705c016bf18f9f73c7","7":"9792b413b5a274ce46bf46d519555576faa75f82","8":"4ad82c5e","9":"component---src-pages-integration-builder-sections-code-tsx","18":"3dcc3d58","29":"c46c4a8f","32":"component---src-pages-404-js","33":"component---src-pages-banner-js","34":"component---src-pages-classic-home-js","35":"component---src-pages-docs-template-js","36":"component---src-pages-home-js","37":"component---src-pages-index-js","38":"component---src-pages-integration-builder-index-tsx","39":"component---src-pages-integration-builder-sections-build-tsx","40":"component---src-pages-integration-builder-sections-card-generator-tsx","41":"component---src-pages-integration-builder-sections-configure-tsx","42":"component---src-pages-integration-builder-sections-demo-tsx","43":"component---src-pages-integration-builder-sections-help-modal-tsx","44":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","45":"component---src-pages-integration-builder-sections-preview-tsx","46":"component---src-pages-integration-builder-sections-take-live-tsx","47":"component---src-pages-internal-js","48":"component---src-pages-signup-js","49":"component---src-pages-signupauto-js","50":"component---src-pages-support-js","51":"component---src-pages-thankyou-js","52":"component---src-pages-unsubscribe-js","53":"component---src-templates-template-layout-js","57":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"bbd22f45773578aaa044","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
